import { RequestContext, QueryParameters } from 'DVWebNodeUtils'
import { makeUrl } from './urlGen'

export interface IUrlData {
  queryParameters: QueryParameters
  originalURI: string
}

const removeRef = (queryParameters: QueryParameters) => {
  const copiedParams = Object.assign({}, queryParameters)
  delete copiedParams['ref_']
  return copiedParams
}

export const buildCurrentUrlWithLocaleReftag = (context: RequestContext, refTag: string) => {
  const urlData: IUrlData = { queryParameters: removeRef(context.queryParameters), originalURI: context.originalURI }
  return makeUrl(context.path, {urlData, get: {
    ie: 'UTF8'
  }, refTag})
}
